/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./infoDialog.vue?vue&type=template&id=0c4d87e5&scoped=true&"
import script from "./infoDialog.vue?vue&type=script&lang=js&"
export * from "./infoDialog.vue?vue&type=script&lang=js&"
import style0 from "./infoDialog.vue?vue&type=style&index=0&id=0c4d87e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4d87e5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VChip,VCol,VDataTable,VIcon,VProgressCircular,VProgressLinear,VRow})
